module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-2200.a9fbb2f4.svg";